require('../proposals/global-this');
require('../proposals/promise-all-settled');
require('../proposals/promise-any');
require('../proposals/string-match-all');
require('../proposals/string-replace-all');
var path = require('../internals/path');

module.exports = path;
